<e-advanced-table class="dock-y" [items]="presentUsers" [headers]="headers">
  <ng-container eTableColumn="lastChangedOn">
    <ng-template eTableCell let-item="item">
      {{ item.lastChangedOn | dateTimeFormat: 'standard' }}
    </ng-template>
  </ng-container>

  <ng-container eTableRow>
    <ng-template eTableRowMenu let-item="item">
      <e-dropdown-menu-item
        icon="sign-out-alt"
        iconColor="danger-75"
        featureAccess="forceInvalidate"
        (click)="onInvalidate(item)"
      >
        Afmelden
      </e-dropdown-menu-item>

      <e-dropdown-menu-item
        (click)="onStop(item)"
        iconColor="danger"
        featureAccess="forceStop"
        icon="stop-circle"
        >Afmelden & afwezig
      </e-dropdown-menu-item>
    </ng-template>
  </ng-container>
</e-advanced-table>
